import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import { Box, Container, Typography } from "@mui/material"
import { Fragment, lazy, Suspense } from "react"
import { useSelector } from "react-redux"

const Testimonials = lazy(() => import("./Testimonials"))
const Benefits = lazy(() => import("./Benefits"))
const Plans = lazy(() => import("./Plans"))
const FAQs = lazy(() => import("./FAQs"))
const Cta = lazy(() => import("./CTA"))

function Pricing() {
  return (
    <Fragment>
      <Box component="section" py={{ xs: 5, lg: 10 }}>
        <Container maxWidth={false} fixed>
          <Box
            sx={{
              pb: 10,
              gap: 1,
              mx: "auto",
              display: "flex",
              maxWidth: "900px",
              textAlign: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              color="other.color1"
              variant="displayLarge"
            >Choose a Wellness Plan That Works for You
            </Typography>
            <Typography
              color="other.color1"
              variant="bodyLead"
            >Whether you're just getting started or ready to go all in, our flexible plans are designed to support your emotional wellness—your way.
            </Typography>
          </Box>
          <Box
            sx={{
              mx: "auto",
              maxWidth: 1000,
            }}
          >
            <Suspense fallback={<SectionSkeleton />}>
              <Plans />
            </Suspense>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <Benefits />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Testimonials />
      </Suspense>

      {/* <Suspense fallback={<SectionSkeleton />}>
        <FAQs />
      </Suspense> */}

      <Suspense fallback={<SectionSkeleton />}>
        <Cta />
      </Suspense>
    </Fragment>
  )
}

export default Pricing